import React, { useState, useEffect } from "react";
import { FaHeart, FaStar } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../baseurl";

// ✅ Toast Mixin
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  customClass: {
    popup: "swal2-toast-custom",
  },
});

function InterestButton({ uid, alreadySent = false }) {
  const token = localStorage.getItem("token");
  const [sent, setSent] = useState(alreadySent);
  const [loading, setLoading] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [glitters, setGlitters] = useState([]);

  useEffect(() => {
    setSent(alreadySent);
  }, [alreadySent]);

  const triggerGlitter = () => {
    let arr = [];
    for (let i = 0; i < 8; i++) {
      arr.push({
        id: Math.random(),
        x: Math.random() * 40 - 20,
        y: Math.random() * 40 - 20,
      });
    }
    setGlitters(arr);
    setTimeout(() => setGlitters([]), 800);
  };

  const handleClick = async () => {
    if (!token) {
      Toast.fire({ icon: "warning", title: "Please login first!" });
      return;
    }
    if (loading) return;

    if (sent) {
      Toast.fire({
        icon: "info",
        title: "Interest already sent!",
      });
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${baseurl}sendInterest`,
        { uid },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        setSent(true);
        setAnimate(true);
        triggerGlitter();

        Toast.fire({
          icon: "success",
          title: "Interest Sent!",
        });

        setTimeout(() => setAnimate(false), 900);
      } 
      else if (res.data.message === "Interest already sent") {
        setSent(true);

        Toast.fire({
          icon: "info",
          title: "You already sent interest!",
        });
      }
    } catch (err) {
    //   console.error("Send interest error:", err);

      Toast.fire({
        icon: "error",
        title: err.response?.data?.message || "Error sending interest",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {glitters.map((g) => (
        <span
          key={g.id}
          className="glitter"
          style={{ position: "absolute", left: g.x, top: g.y }}
        ></span>
      ))}

      <button
        onClick={handleClick}
        disabled={loading}
        className={` btn connect-btn me-2 ${sent ? "sent" : "intrestedcls"}`}
         
      >
        <FaHeart
          style={{
            color: sent ? "#A90D4B" : "#ffffffff",
            fontSize: "18px",
            animation: animate ? "pop 0.4s ease-out" : "none",
          }} className="me-1"
        />
        {sent ? "Intrest" : "Intrested"}
      </button>
    </div>
  );
}

export default InterestButton;
